import React from 'react';

const PageIntro = ({ headline }) => {
  return (
    <div className="sec-intro">
      <h1 className="access-elem">{headline}</h1>
      <h2 className="sec-intro__title">{headline}</h2>
    </div>
  );
};

export default PageIntro;
